// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","TimeInfo":"_1fF4Hr","fadeInFrames":"_281W12"};